export default __webpack_public_path__ + "static/media/de01.3036c0d2.jpg";